import App from "@/views/App.vue";

export default [
  {
    path: "/novo-transmissao",
    name: "newTransmissionHome",
    component: App,
    redirect: { name: "newTransmission" },
    children: [
      {
        path: "/novo-transmissao",
        name: "newTransmission",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewTransmission.vue"
          ),
        meta: {
          displayName: "displayName.newTransmission",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-transmissao/:id/",
        name: "editTransmission",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditTransmission.vue"
          ),
        meta: {
          displayName: "displayName.transmissionEdit",
          requiresAuth: true,
        },
      },
      {
        path: "/detalhes-transmissao/:id/",
        name: "settingsTransmissionInfo",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/TransmissionInfo.vue"
          ),
        meta: {
          displayName: "displayName.transmissionDetails",
          requiresAuth: true,
        },
      },
      {
        path: "/transmissao",
        name: "timelineTransmission",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Transmission.vue"),
        meta: {
          displayName: "displayName.transmission",
          requiresAuth: true,
          name: "Exclusive Lounge",
        },
      },
    ],
  },
];
